/**
 * Onboarding API — typed client for the caller's first-run onboarding state.
 *
 * Gateway prefix /api/v1/users → user-service (see api-gateway/src/config.py).
 * Mirrors services-python/user-service/src/api/routes.py:
 *  - GET  /api/v1/users/me/onboarding            → current status
 *  - POST /api/v1/users/me/onboarding/complete   → mark complete (idempotent)
 *
 * Both are strictly self-scoped (`/users/me/...`): they read/write the caller's
 * OWN member row only — there is no user_id parameter to target anyone else.
 */

import { api } from '@/lib/api/client';

const BASE = '/api/v1/users/me/onboarding';

/** Mirrors user-service `OnboardingStatus`. `completed_at` is an ISO timestamp. */
export interface OnboardingStatus {
  completed: boolean;
  completed_at: string | null;
}

/** GET the caller's onboarding status. */
export function getOnboardingStatus(): Promise<OnboardingStatus> {
  return api.get<OnboardingStatus>(BASE);
}

/** POST to mark the caller's onboarding complete (idempotent — keeps the first date). */
export function completeOnboarding(): Promise<OnboardingStatus> {
  return api.post<OnboardingStatus>(`${BASE}/complete`);
}
